// src/components/layout/AuthLayout.js
import logoGestinet from 'assets/img/favicon.png'
import logoGestinetText from 'assets/img/logo-gestinet.png'
import LanguageSelector from 'components/ui/LanguageSelector'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LuChartColumn, LuMessageSquare, LuPhone } from 'react-icons/lu'

// Diseño compartido de las pantallas sin sesión: login, recuperar y cambiar contraseña
export default function AuthLayout({ subtitle, children }) {
  const { t } = useTranslation()

  const features = [
    { icon: LuPhone, text: t('auth_panel.feature_calls') },
    { icon: LuMessageSquare, text: t('auth_panel.feature_chat') },
    { icon: LuChartColumn, text: t('auth_panel.feature_stats') },
  ]

  return (
    <div className="flex min-h-screen flex-wrap bg-white text-gray-900">
      <main className="flex min-w-0 flex-[1_1_480px] flex-col px-6 py-6 sm:px-8">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <img src={logoGestinet} alt="Gestinet" className="h-8 w-8" />
            <span className="text-[15px] font-semibold tracking-tight">GestioAI</span>
          </div>
          <LanguageSelector variant="light" />
        </div>

        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-12">
          <p className="mb-8 text-[15px] text-gray-600">{subtitle}</p>
          {children}
        </div>

        <span className="text-sm text-gray-500">© Gestinet</span>
      </main>

      <aside className="hidden min-w-0 flex-[1_1_480px] flex-col justify-center gap-9 bg-brand px-16 py-16 text-white lg:flex">
        {/* El PNG es gris claro: brightness-0 + invert lo deja en blanco sobre el azul */}
        <img src={logoGestinetText} alt="Gestinet · Talent & IT Services" className="h-32 w-fit max-w-full object-contain object-left brightness-0 invert xl:h-36" />
        <div className="flex max-w-md flex-col gap-4">
          <span className="text-[44px] font-semibold leading-[1.1] tracking-tight">{t('auth_panel.title')}</span>
          <span className="text-[17px] leading-relaxed text-white/80">{t('auth_panel.subtitle')}</span>
        </div>
        <ul className="flex max-w-md flex-col gap-3.5">
          {features.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-3 text-[15px]">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-white/10">
                <Icon size={16} aria-hidden="true" />
              </span>
              {text}
            </li>
          ))}
        </ul>
      </aside>
    </div>
  )
}

AuthLayout.propTypes = {
  subtitle: PropTypes.node,
  children: PropTypes.node
}
